<script>
	import { onMount } from "svelte";
	import Available from "./Available.svelte";
	import Login from "./Login.svelte";
	import GetEntries from "./GetEntries.svelte";
	import { Router, Route, Link, navigate } from "svelte-routing";
	import jwt_decode from "jwt-decode";
	import { jwt } from "../stores/jwtstore";
	import {
		Row,
		Column,
		Content,
		Grid,
		Header,
		HeaderGlobalAction,
		HeaderUtilities,
	} from "carbon-components-svelte";
	import BrightnessContrast20 from "carbon-icons-svelte/lib/BrightnessContrast20/BrightnessContrast20.svelte";
	import Logout20 from "carbon-icons-svelte/lib/Logout20/Logout20.svelte";
	import config from "../config/config.json";
	import { routerBasepath } from "../config/const";

	const {
		basepath: { production, development },
	} = config;

	let isconnected = false;

	const disconnect = (e) => {
		localStorage.removeItem("jwt");
		jwt.set("");
	};

	let themes = ["white", "g100"];
	let curtheme = 0;

	const toggletheme = () => {
		curtheme = (curtheme + 1) % themes.length;
		document.documentElement.setAttribute("theme", themes[curtheme]);
	};

	onMount(() => {
		console.log("onmount");
		document.documentElement.setAttribute("theme", themes[curtheme]);
		const storedjwt = localStorage.getItem("jwt");
		console.log(storedjwt);
		if (
			storedjwt != null &&
			storedjwt != "" &&
			typeof storedjwt != "undefined" &&
			storedjwt != "undefined"
		) {
			console.log(storedjwt);
			jwt.set(storedjwt);
		}
	});

	const jwtunsubscribe = jwt.subscribe((value) => {
		console.log("jwtsubscribe");
		if (value == "") {
			if (!localStorage.getItem("jwt")) {
				localStorage.removeItem("jwt");
			}
			isconnected = false;
			return;
		}
		try {
			const { exp } = jwt_decode(value);
			if (exp < Date.now() / 1000) {
				isconnected = false;
				jwt.set("");
				localStorage.removeItem("jwt");
				return;
			}
			isconnected = true;
		} catch (e) {
			jwt.set("");
		}
	});

	const url = "";
</script>

<main>
	<!-- <Theme bind:theme /> -->
	<Router basepath={routerBasepath} {url}>
		<Header on:click={() => navigate("getentries")}>
			<img
				slot="platform"
				class="headerimg"
				alt="logo_greenwalk"
				src="http://www.greenwalk.me/spotroom2/logo_greenwalk.png"
				on:click={() => navigate("getentries")}
			/>
			<HeaderUtilities>
				<HeaderGlobalAction
					aria-label="Settings"
					icon={BrightnessContrast20}
					on:click={toggletheme}
				/>
				{#if isconnected}
					<HeaderGlobalAction
						aria-label="Disconnect"
						icon={Logout20}
						on:click={disconnect}
					/>
				{/if}
			</HeaderUtilities>
		</Header>
		<Content style="background: none">
			<Grid fullWidth>
				{#if !isconnected}
					<Route path="">
						<Login />
					</Route>
				{/if}
				{#if isconnected}
					<Route path={"makebooking"}>
						<Available />
					</Route>
					<Route path={"getentries"}>
						<GetEntries />
					</Route>
					<Route path="">
						<GetEntries />
					</Route>
				{/if}
			</Grid>
		</Content>
	</Router>
</main>

<style>
	main {
		text-align: center;
		margin: 0 auto;
		padding: 0.1rem;
	}
	.headerimg {
		cursor: pointer;
		max-width: 100%;
		max-height: 100%;
	}
</style>
